import { useEffect, useState } from "react";
import FlexRow from "../../../../components/base/FlexRow";
import Icon from "../../../../components/base/Icon";
import moment from "moment";
import { useHub } from "../../../../core/Global";

interface IProps {
    amount: number
}
export default function BalancePayedCard(props: IProps) {

    const moneyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });

    const hub = useHub()

    const [selectedDateLabel, selectedDateLabelSet] = useState<string>("Today")
    const [loading, loadingSet] = useState<boolean>(false)

    const [dateId, dateIdSet] = useState<number>(0)
    const [startDate, startDateSet] = useState<any>()
    const [endDate, endDateSet] = useState<any>()

    const [totalPayed, totalPayedSet] = useState<number>(0)


    useEffect(() => {

        ($("#payed-daterange") as any).daterangepicker({
            startDate: moment(),
            endDate: moment(),
            autoUpdateInput: false,
            timePicker: false,
            ranges: {
                "Today": [moment(), moment()],
                "Yesterday": [moment().subtract(2, "days"), moment().subtract(1, "days")],
                "Current Week": [moment().subtract(3, "days"), moment().subtract(1, "days")],
                "Last Week": [moment().subtract(4, "days"), moment().subtract(1, "days")],
                "Current Month": [moment().subtract(6, "days"), moment().subtract(1, "days")],
            }
        }, (start: any, end: any, label: any) => {
            console.log(start, end, label)
            if (label == "Custom Range") {

                dateIdSet(99)
                startDateSet(start)
                endDateSet(end)
                selectedDateLabelSet(start.format("DD MMM") + " - " + end.format("DD MMM"))

            }
            else {

                selectedDateLabelSet(label)
                if (label == "Today") fetch(1)
                if (label == "Yesterday") fetch(2)
                if (label == "Current Week") fetch(3)
                if (label == "Last Week") fetch(4)
                if (label == "Current Month") fetch(6)

            }
        });



    }, [])


    const fetch = (dateId: number) => {
        loadingSet(true)
        hub.Post("/reports/jobs/techbalance", {
            techsBalanceDate: {
                dateId: dateId
            }
        }, res => {
            loadingSet(false)
        })
    }



    return (
        <div className="card">
            <div className="card-body">

                <FlexRow className="mb-5">
                    <Icon icon={"arrow-right-from-arc" as any} className="fs-2hx text-gray-600" />
                    {/* <div className="ms-auto">
                        <span id="payed-daterange" className="badge badge-light-primary cursor-pointer">
                            <span className="me-3">
                                {selectedDateLabel}
                            </span>
                            {
                                loading ? <Icon icon="spinner-third" spin />
                                    : <Icon icon="chevron-down" />
                            }
                        </span>
                    </div> */}
                </FlexRow>
                <div className="d-flex flex-column">
                    <span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2 mb-2">
                        {moneyFormatter.format(props.amount)}
                    </span>
                    <div className="m-0">
                        <span className="fw-semibold fs-6 text-gray-500">Total Payed</span>
                    </div>
                </div>

            </div>
        </div>
    )
}